// Seasonal banner presets for the 2026 festival calendar.
// Used by the /admin/banner control page to one-click prefill the homepage banner.
export const BANNER_PRESETS = [
  {
    id: "rakhi", label: "Rakshabandhan",
    title: "Rakshabandhan Edit", subtitle: "Ethnic sets & festive kurtis for the celebration",
    cta_text: "Shop Rakhi Looks", cta_link: "/shop?collection=kurtis",
    bg: "#B84A3B", fg: "#FFFFFF",
  },
  {
    id: "onam", label: "Onam 2026",
    title: "Onam 2026 Collection", subtitle: "Kasavu elegance & festive whites",
    cta_text: "Shop Onam", cta_link: "/shop?collection=onam2026",
    bg: "#1A6B4A", fg: "#FFFFFF",
  },
  {
    id: "navratri", label: "Navratri / Garba",
    title: "Navratri & Garba Nights", subtitle: "Chaniya cholis & twirl-ready sets",
    cta_text: "Shop Navratri", cta_link: "/shop?collection=garba",
    bg: "#7A2E8C", fg: "#FFFFFF",
  },
  {
    id: "ganpati", label: "Ganpati",
    title: "Ganesh Chaturthi Picks", subtitle: "Graceful sarees & festive wear",
    cta_text: "Shop the Edit", cta_link: "/shop?collection=sarees",
    bg: "#C8641E", fg: "#FFFFFF",
  },
  {
    id: "karwachauth", label: "Karwa Chauth",
    title: "Karwa Chauth Glam", subtitle: "Reds, maroons & statement looks",
    cta_text: "Shop Karwa Chauth", cta_link: "/shop?collection=karwa-chauth-collection",
    bg: "#8A1E3B", fg: "#FFFFFF",
  },
  {
    id: "diwali", label: "Diwali",
    title: "Diwali Festive Sale", subtitle: "Dazzling party wear for the festival of lights",
    cta_text: "Shop Diwali", cta_link: "/shop?collection=reception-cocktail-party",
    bg: "#1A1A1A", fg: "#F5C542",
  },
  {
    id: "sale", label: "Festive Sale",
    title: "Festive Sale — Up to 60% Off", subtitle: "Limited-time markdowns across the store",
    cta_text: "Shop the Sale", cta_link: "/shop",
    bg: "#B84A3B", fg: "#FFFFFF",
  },
];

export const findPreset = (id) => BANNER_PRESETS.find((p) => p.id === id);
